import { render, staticRenderFns } from "./tab-menu-context.vue?vue&type=template&id=4ed1f8f8&scoped=true"
import script from "./tab-menu-context.vue?vue&type=script&lang=js"
export * from "./tab-menu-context.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed1f8f8",
  null
  
)

export default component.exports